import { defineComponent } from "vue";
import Svg from "../../core/svg";
import { DefaultVueProp, refMethod, VueProp } from "../../core/vueHelpers";
import { Classes } from "../classes";
import { PortalButtonData } from "../menuData";
import { FocusHandler } from "./focusHandler";

export default /*#__PURE__*/ defineComponent(
{
    name: "portalButton",
    props:
    {
        portalButtonData: VueProp<PortalButtonData>(),
        isSelected: DefaultVueProp(false),
        focusHandler: VueProp<FocusHandler>()
    },
    emits:
    {
        selectPortal: null as unknown as (portalButtonData: PortalButtonData) => boolean
    },
    render()
    {
        let tokens:string[] = [];
        if (this.portalButtonData.displayText !== null)
        {
            tokens = this.portalButtonData.displayText.split(" ");
        }

        const lowerString = tokens.pop();
        const upperString = tokens.join(" ");

        return (
            <a
                ref={refMethod<HTMLElement>((elem) => this.focusHandler.setPortalButton(this.portalButtonData, elem))}
                class={[this.isSelected ? Classes.currentPortalButton : Classes.portalButton, "light-focus"]}
                href="javascript:void(0)"
                aria-label={"View modules for " + this.portalButtonData.displayText}
                role="tab"
                aria-controls={Classes.portalContent}
                aria-selected={this.isSelected}
                onClick={() => { this.$emit("selectPortal", this.portalButtonData); }}
                onKeydown={(e: KeyboardEvent) => onKeyDown(this.focusHandler, this.portalButtonData, e)}
            >
                <Svg class={Classes.portalButtonIcon} name={this.portalButtonData.icon!} aria-hidden="true" type="PortalButtons" showHoverEffect={false} />
                <span class={Classes.portalButtonTextContainer}>
                    <span class={Classes.portalButtonText}>{upperString}</span>
                    <span class={Classes.portalButtonText}>{lowerString}</span>
                </span>
            </a>
        );
    }
});

function onKeyDown(focusHandler: FocusHandler, portalButtonData: PortalButtonData, e: KeyboardEvent): void
{
    if (focusHandler.moveFocusFromPortal(portalButtonData, e))
    {
        e.preventDefault();
    }
}